import { apiClient } from '../../axios';
import { GetLaunchpoolHistoryResponse, GetLaunchpoolResponse } from './types';

export const getLaunchpoolApi = () => apiClient.get<GetLaunchpoolResponse>('/v1/launchpool');

export const postLaunchPoolStakeApi = ({
  launchpoolId,
  params,
}: {
  launchpoolId: number;
  params: { amount: string };
}) => apiClient.post(`/v1/launchpool/${launchpoolId}/stake`, params);

export const postLaunchPoolUnstakeApi = (launchpoolId: number) =>
  apiClient.post(`/v1/launchpool/${launchpoolId}/unstake`);

export const getLaunchpoolHistoryApi = () => apiClient.get<GetLaunchpoolHistoryResponse>('/v1/launchpool/history');

export const getLaunchpoolHistoryByLaunchpoolIdApi = (launchpoolId: string) =>
  apiClient.get<GetLaunchpoolHistoryResponse>(`/v1/launchpool/history`, { params: { launchpoolId } });

export const postLaunchpoolAutoConversionApi = ({
  launchpoolId,
  data,
}: {
  launchpoolId: number;
  data: { turnOn: boolean };
}) => apiClient.put(`/v1/launchpool/${launchpoolId}/auto-conversion`, data);
